module.exports = __webpack_public_path__ + "img/case-月星.2cd26a1a.png";